module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13%税率的项目")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_1),
      expression: "A_1_1"
    }],
    domProps: {
      "value": (_vm.A_1_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_2),
      expression: "A_1_2"
    }],
    domProps: {
      "value": (_vm.A_1_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_1_3),
      expression: "A_1_3"
    }],
    domProps: {
      "value": (_vm.A_1_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_1_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.A_1_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_1_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_1_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9%税率的项目")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_1),
      expression: "A_2_1"
    }],
    domProps: {
      "value": (_vm.A_2_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_2),
      expression: "A_2_2"
    }],
    domProps: {
      "value": (_vm.A_2_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_2_3),
      expression: "A_2_3"
    }],
    domProps: {
      "value": (_vm.A_2_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_2_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_2_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率的项目（不含金融商品转让）")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_1),
      expression: "A_3_1"
    }],
    domProps: {
      "value": (_vm.A_3_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_2),
      expression: "A_3_2"
    }],
    domProps: {
      "value": (_vm.A_3_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_3_3),
      expression: "A_3_3"
    }],
    domProps: {
      "value": (_vm.A_3_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_3_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_3_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6%税率的金融商品转让项目")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_1),
      expression: "A_4_1"
    }],
    domProps: {
      "value": (_vm.A_4_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_2),
      expression: "A_4_2"
    }],
    domProps: {
      "value": (_vm.A_4_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_4_3),
      expression: "A_4_3"
    }],
    domProps: {
      "value": (_vm.A_4_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_4_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_4_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5%征收率的项目")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_1),
      expression: "A_5_1"
    }],
    domProps: {
      "value": (_vm.A_5_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_2),
      expression: "A_5_2"
    }],
    domProps: {
      "value": (_vm.A_5_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_5_3),
      expression: "A_5_3"
    }],
    domProps: {
      "value": (_vm.A_5_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_5_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_5_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3%征收率的项目")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_1),
      expression: "A_6_1"
    }],
    domProps: {
      "value": (_vm.A_6_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_2),
      expression: "A_6_2"
    }],
    domProps: {
      "value": (_vm.A_6_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_6_3),
      expression: "A_6_3"
    }],
    domProps: {
      "value": (_vm.A_6_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_6_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_6_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免抵退税的项目")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_1),
      expression: "A_7_1"
    }],
    domProps: {
      "value": (_vm.A_7_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_2),
      expression: "A_7_2"
    }],
    domProps: {
      "value": (_vm.A_7_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_7_3),
      expression: "A_7_3"
    }],
    domProps: {
      "value": (_vm.A_7_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_7_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_7_6) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免税的项目")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_1),
      expression: "A_8_1"
    }],
    domProps: {
      "value": (_vm.A_8_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_2),
      expression: "A_8_2"
    }],
    domProps: {
      "value": (_vm.A_8_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.A_8_3),
      expression: "A_8_3"
    }],
    domProps: {
      "value": (_vm.A_8_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.A_8_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_4) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_5) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n         " + _vm._s(_vm.A_8_6) + "\n      ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("增值税纳税申报表附列资料（三）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("（服务、不动产和无形资产扣除项目明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2",
      "rowspan": "3"
    }
  }, [_vm._v("项目及栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("本期服务、不动产和无形资产价税合计额（免税销售额）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("服务、不动产和无形资产扣除项目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("期初余额")]), _vm._v(" "), _c('td', [_vm._v("本期发生额")]), _vm._v(" "), _c('td', [_vm._v("本期应扣除金额")]), _vm._v(" "), _c('td', [_vm._v("本期实际扣除金额")]), _vm._v(" "), _c('td', [_vm._v("期末余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4=2+3")]), _vm._v(" "), _c('td', [_vm._v("5(5≤1且5≤4)")]), _vm._v(" "), _c('td', [_vm._v("6=4-5")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24681bce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nssb/table3.vue
// module id = 711
// module chunks = 1